/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import styles from "./IoBoardListItem.module.scss";
import { parseEnumStart } from "../../../../utils/utils";
import arrow_right from "../../../../images/arrow-right.svg";
import pcba from "../../../../images/PCBA.svg";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const IoBoardListItem = (props: any): JSX.Element => {
  const { title, onRowItemClick, selectedNodeId, nodes, onBoardEditClick } = props;

  return (
    <li className={styles.Wrapper}>
      <div className={styles.BoardInfoRow}>
        <div className={styles.Icon}>
          <img alt="pcba" src={pcba} width="20" />
        </div>

        <div className={styles.Title}>
          <span>{title}</span>
        </div>
        {onBoardEditClick && (
          <div className={styles.Edit}>
            <button onClick={() => onBoardEditClick()}>Edit</button>
          </div>
        )}
      </div>

      <div className={styles.Nodes}>
        {nodes.map((node: Api.IoNode | Api.StandardNode, index: number) => {
          const classes = [styles.NodeNetworkName, styles.showOnHover];
          classes.push(selectedNodeId === node.id ? styles.OpenedListItem : "");
          return (
            <div key={node.id} className={styles.Node}>
              {index + 1 === nodes.length ? (
                <div className={styles.ConnectorSymbolLast} />
              ) : (
                <div style={{ height: "100%" }}>
                  <div className={styles.ConnectorSymbolLast} />
                  <div className={styles.ConnectorSymbol} />
                </div>
              )}

              <div className={classes.join(" ")}>
                <div className={styles.Title} onClick={() => onRowItemClick(node)}>
                  <span>{parseEnumStart(node.cpu.enumName, 2)} &#91;{node.cpu.enumValue}&#93;</span>
                  <img src={arrow_right} alt="arrow" /> <span>{node.network.enumName} &#91;{node.network.enumValue}&#93;</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </li>
  );
};

export default IoBoardListItem;
